import { createAsyncThunk } from "@reduxjs/toolkit";
import customerSubscriptionService from "services/customerSubscription";

export const subscribeAsync = createAsyncThunk(
  "subscribers/subscribe",
  async ({ data }) => {
    const res = await customerSubscriptionService.subscribe(data);
    return res.data;
  }
);

export const changeSubscriptionPlanAsync = createAsyncThunk(
  "subscribers/changePlan",
  async ({ data }) => {
    const res = await customerSubscriptionService.changePlan(data);
    return res.data;
  }
);
